import { HttpClient, HttpParams, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, Subject, throwError } from "rxjs";
import { map, catchError} from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class TemplateUploadService{
    public API_URL: string = '';
    private ohEntityViewerBase : string = '';
    private entityViewerUnconfiguredFile : string = '';
    public uploadDetail$ = new Subject<any>();
    
    constructor(private readonly httpClient: HttpClient){
        this.API_URL = window['environmentVariableConfig']['configUIApiUrl'];
        this.ohEntityViewerBase = window['environmentVariableConfig']['ohEntityViewerBase'];
        this.entityViewerUnconfiguredFile = window['environmentVariableConfig']['entityViewerUnconfiguredFile'];
    }
    public uploadFile(request): Observable<any> {
        this.ohEntityViewerBase = window['environmentVariableConfig']['ohEntityViewerBase'];
        const formData = new FormData();
        formData.append('File', request);
        formData.append('Path', `${this.ohEntityViewerBase}/OHEntityViewer/`);
        
        return this.httpClient.post(`${this.API_URL}/api/filehandler/files/upload`, formData, {
            reportProgress: true,
            observe: 'events',
          })
    }

    public downloadFile(filePath : string[], folderName : string): Observable<HttpResponse<Blob>>{
      this.API_URL = window['environmentVariableConfig']['configUIApiUrl'];
      this.ohEntityViewerBase = window['environmentVariableConfig']['ohEntityViewerBase'];
      this.entityViewerUnconfiguredFile = window['environmentVariableConfig']['entityViewerUnconfiguredFile'];
      let fileToDownload = []
      if(filePath.length != 0){
        filePath.forEach((path) => {
          fileToDownload.push(`${this.ohEntityViewerBase}/` + path);
        });
      } else {
        fileToDownload = [`${this.ohEntityViewerBase}/${this.entityViewerUnconfiguredFile}`];
      }
      return this.httpClient.post<Blob>(`${this.API_URL}/api/filehandler/files/download`,
        {
          "DownloadFileName" : folderName + ".zip",
          "Path": fileToDownload,
        },{ 
          observe: 'response', responseType: 'blob' as 'json'
        });
    }

      public processFile(path: string,assetType,plant,plantId): Observable<any>{
        return this.httpClient.post<Blob>(`${this.API_URL}/api/entity-viewer-config/configuration/entityviewer/addconfig`,
        {
          path,assetType,plantName:plant,plantId
        })
      }

      public getTemplateList(plantName,assetType,plantId): Observable<any>{
        this.API_URL = window['environmentVariableConfig']['configUIApiUrl'];
        let params =  new HttpParams();
        if(assetType !== null) {
           params = params.append('asset_type', assetType);
          params = params.append('plant_id', plantId);
        } else {
          params = params.append('plant_id', plantId);
        }
        return this.httpClient.get(`${this.API_URL}/api/entity-viewer-config/configuration/entityviewer/getconfig`, { params })
        .pipe(
          map(data => data['EntityViewerConfigs'].map(item => {
            return { PlantName:plantName, ...item }
          })),

         catchError((err) => {
            console.error(err);
            return throwError(()=>err);
          }) 
        )
      }

      public getPlantsList():Observable<any> {
        this.API_URL = window['environmentVariableConfig']['configUIApiUrl'];
        return this.httpClient.get(`${this.API_URL}/api/oh-module/plantlist`).pipe(
          catchError((err) => {
            console.error(err);
            return throwError(()=>err);    //Rethrow it back to component
          })
        )
      }

      public getChildList(plantId):Observable<any> {
        this.API_URL = window['environmentVariableConfig']['configUIApiUrl'];
        return this.httpClient.get(`${this.API_URL}/api/oh-module/assettypes/byplant?asset_id=${plantId}`).pipe(
          catchError((err) => {
            console.error(err);
            return throwError(()=>err);    //Rethrow it back to component
          })
        )
    }
}